import React from 'react'
import './styles.scss'
import Message from 'components/InChatView/ChatMessages/Message'
import MessageReactions from 'components/InChatView/ChatMessages/MessageReactions'
import { getFormatedDate } from 'utils'
import { getStaticImage } from 'utils/statics'
import { apiInchat } from 'api'
import { toastMessage } from 'utils/messages'
import { lang } from 'utils/helpers'

const Container = ({ message, operator, title, isReactions, updateDataMentions }) => {
  const handleSavedMessages = async () => {
    try{
      if (message.isSave){
        await apiInchat.removeSaveMessage({ id: message._id })
      }else{
        await apiInchat.saveMessage({ conversationId: message.conversationId, messageId: message._id })
      }
      updateDataMentions()
    } catch (error) {
      if(message.isSave) return toastMessage(lang('dashboard_message_error_unsaved'), 'error')
      return toastMessage(lang('dashboard_message_error_saved'), 'error')
    }
  }

  return (
    <div className='inchat-mentions-card'>
      <div className='inchat-mentions-card__left'>
        {title}
        <Message
          message={{ ...message, isSave: false }}
          operatorId={operator.id}
          showReactions={isReactions}
          showAvatar={message.userId !== operator.id}
          showOptions={false}
          showNumberReactions={false}
          showSelector={false}
          onPressSelectEmoji={updateDataMentions}
          isChat={false}
        />
      </div>
      <div className='inchat-mentions-card__right'>
        <div className='inchat-mentions-card__right--icons'>
          <MessageReactions
            conversationId={message.conversationId}
            messageId={message._id}
            reactions={message.reactions || []}
            showReactions={false}
            isDark
            onPressSelect={updateDataMentions}
            isChat={false}
            showEmoji={false}
          />
          <button
            onClick={handleSavedMessages}
            className='inchat-mentions-card__button'
          >
            <img
              src={message.isSave ? getStaticImage('/icons/orange-brand/icon-saved.svg') : getStaticImage('/icons/orange-brand/icon-menu-saved.svg')}
              alt={'save'}
            />
          </button>
        </div>
        <span className='inchat-mentions-card__right--date'>{getFormatedDate({ isoString: message.sentAt, withTime: true, withYear: true })}</span>
      </div>
    </div>
  )
}

export default Container